import React from 'react';

// CSV export fallback modal. Iframe-safe — uses a textarea + Blob URL.
// Kept as a self-contained component so BundleBuilder stays focused on bundle logic.
export const ExportCsvModal = ({ exportModal, copyStatus, onClose, onDownload, onCopy }) => {
  if (!exportModal) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      onClick={onClose}
      data-testid="export-modal-overlay"
    >
      <div
        className="bg-surface border border-border-color rounded-xl p-6 max-w-2xl w-full max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-2">
          <div>
            <h3 className="text-xl font-bold font-heading text-text-primary">Export Bundle CSV</h3>
            <p className="text-sm text-text-secondary mt-1">
              File: <span className="text-gold">{exportModal.filename}</span>
            </p>
          </div>
          <button
            onClick={onClose}
            data-testid="close-export-modal"
            className="text-text-secondary hover:text-text-primary text-2xl leading-none px-2"
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <textarea
          id="export-csv-textarea"
          readOnly
          value={exportModal.csv}
          data-testid="export-csv-textarea"
          className="flex-1 min-h-[260px] my-4 p-3 bg-black border border-border-color rounded-lg text-text-primary text-xs font-mono focus:border-gold focus:outline-none resize-none"
          onClick={(e) => e.target.select()}
        />
        <div className="flex flex-wrap gap-3 justify-end items-center">
          {copyStatus === 'copied' && (
            <span className="text-sm text-success" data-testid="copy-status">Copied to clipboard</span>
          )}
          {copyStatus === 'select' && (
            <span className="text-sm text-warning" data-testid="copy-status">Press Ctrl/Cmd+C to copy</span>
          )}
          <button
            onClick={onCopy}
            data-testid="copy-csv-button"
            className="px-4 py-2 border border-border-color text-text-primary rounded-lg hover:border-gold hover:text-gold"
          >
            Copy CSV
          </button>
          <button
            onClick={onDownload}
            data-testid="download-csv-button"
            className="px-4 py-2 bg-gold text-black font-bold rounded-lg hover:bg-gold-hover"
          >
            Download .csv
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportCsvModal;
